module.exports = __webpack_public_path__ + "static/media/TotalDebitsSettledApplicantPortal.060d56ba.svg";